import React, { ReactElement, useRef, useState } from 'react';
import arrowDown from '../../../assets/img/svg/table/arrow-down.svg';
import arrowUp from '../../../assets/img/svg/table/arrow-up.svg';
import { useCloseOnScrollAndClickOutside } from '../../../hook/useCloseOnScrollAndClickOutside';

interface CategoryItemProps {
  icon: string;
  label: string;
  children: ReactElement;
}
const CategoryItem: React.FC<CategoryItemProps> = ({ icon, label, children }) => {
  const [open, setOpen] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useCloseOnScrollAndClickOutside(setOpen, menuRef);

  return (
    <div className="category_item" ref={menuRef}>
      <div className="category_header" onClick={() => setOpen(!open)}>
        <div className="title">
          <img src={icon} alt={label} />
          <span>{label}</span>
        </div>
        <img className={`arrow ${open ? 'open' : ''}`} src={open ? arrowUp : arrowDown} alt="arrow" />
      </div>
      <div className={`category_dropdown ${open ? 'open' : ''}`}>{children}</div>
    </div>
  );
};

export default CategoryItem;
